import pages from '../../api/pages'

// initial state
const state = {
  sitemap: [],
  content: [],

  dataWaitPeriod: process.env.VUE_APP_DATA_AUTO_RELOAD_SECONDS,
  dataLastRun: null,

  appWaitPeriod: process.env.VUE_APP_APP_AUTO_RELOAD_SECONDS,
  appLastRun: null
}

// getters
const getters = {
  sitemap: state => {
    return state.sitemap
  },
  content: state => {
    return state.content
  },
  dataWaitPeriod: state => {
    return state.dataWaitPeriod
  },
  dataLastRun: state => {
    return state.dataLastRun
  },
  appWaitPeriod: state => {
    return state.appWaitPeriod
  },
  appLastRun: state => {
    return state.appLastRun
  }
}

// actions
const actions = {

  getAllContent ({ dispatch, commit }) {
    dispatch('getSitemap')
    dispatch('getContent')
    dispatch('logData')
  },

  getSitemap ({ commit }) {
    pages.getSitemap(sitemap => {
      commit('setSitemap', sitemap)
    })
  },

  getContent ({ commit }) {
    pages.getContent(content => {
      commit('setContent', content)
    })
  },

  logData ({ commit }) {
    commit('setDataLastRun', Math.round(new Date() / 1000))
  },

  logApp ({ commit }) {
    commit('setAppLastRun', Math.round(new Date() / 1000))
  }
}

// mutations
const mutations = {
  setSitemap (state, sitemap) {
    state.sitemap = sitemap
  },

  setContent (state, content) {
    state.content = content
  },

  setDataLastRun (state, dataLastRun) {
    state.dataLastRun = dataLastRun
  },

  setAppLastRun (state, appLastRun) {
    state.appLastRun = appLastRun
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
